<msf-list-page-wrapper [leftSize]="'9'" [rightSize]="'3'" [rightBackground]="true">

  <div left #left>
    <div class="gis-page">
      <p-toast></p-toast>

      <div class="page-header">
        @if (filterModel?.regionId || filterModel?.CROPS) {
          <app-back-button
            (back)="filterModel.regionId = null; filterModel.CROPS = null; selectedCrops = null; filterFieldsChange()">
          </app-back-button>
        } @else {
          <app-back-button [parentRoute]="'/weather'"></app-back-button>
        }

        <h1 class="page-title">
          {{ getRegionPathString() }}
        </h1>
      </div>

      <div class="map-wrapper">
        <div class="map-container"
             [class.drawing-mode]="currentDrawingState.isDrawing && (currentDrawingState.drawingType === 'polygon' || currentDrawingState.drawingType === 'rectangle')">
          <!-- OpenStreetMap Component -->
          <app-openstreetmap
            #openstreetmapComponent
            style="width: 100%;"
            [mapController$]="mapController$"
            [mapOptions]="mapOptions"
            [showIndexPanel]="false"
            (legendCloseClicked)="onLegendClose()"
            (indexLayerApplied)="onIndexLayerApplied()">
          </app-openstreetmap>

          <!-- Region Names Control -->
          <div class="map-region-names-control">
            <msf-multi-select
              [(model)]="selectedMapDisplayOptions"
              [options]="mapDisplayOptions"
              [placeholder]="'Show' | translate"
              [maxSelectedLabels]="2"
              [width]="'285px'"
              (modelChange)="onMapDisplayOptionsChange($event)">
            </msf-multi-select>
          </div>

          <!-- Weather Legend Component -->
          <app-weather-legend
            [selectedWeatherLayer]="selectedWeatherLayer"
            [visible]="showWeatherLegend">
          </app-weather-legend>

          @if (
            hasWeatherLayer()
            || hasIndexLayer()
            || (
              openstreetmapComponent?.currentMapLayer === 'satellite'
              && (
                openstreetmapComponent?.currentSatelliteLayer === 'sentinel'
                || openstreetmapComponent?.currentSatelliteLayer === 'landsat'
              )
            )
          ) {
            <div class="map-active-layers-control">
              @if (
                openstreetmapComponent?.currentMapLayer === 'satellite'
                && (
                  openstreetmapComponent?.currentSatelliteLayer === 'sentinel'
                  || openstreetmapComponent?.currentSatelliteLayer === 'landsat'
                )
              ) {
                <div class="opacity-control-container" [class.is-hidden]="!layerStates.satellite.visible" [title]="openstreetmapComponent.currentSatelliteLabel">
                  <span class="opacity-icon">
                      <i class="pi pi-map"></i>
                  </span>
                  <input
                    type="range"
                    min="0"
                    max="100"
                    [ngModel]="layerStates.satellite.opacity"
                    (ngModelChange)="onLayerOpacityChange('satellite', $event)"
                    [disabled]="!layerStates.satellite.visible"
                    class="opacity-slider">
                  <span class="opacity-value">{{ layerStates.satellite.opacity }}%</span>
                  <button
                    type="button"
                    class="visibility-toggle"
                    (click)="toggleLayerVisibility('satellite')">
                    <i class="pi" [class.pi-eye]="layerStates.satellite.visible" [class.pi-eye-slash]="!layerStates.satellite.visible"></i>
                  </button>
                </div>
              }

              @if (hasWeatherLayer()) {
                <div class="opacity-control-container" [class.is-hidden]="!layerStates.weather.visible" [title]="getWeatherLayerLabel()">
                  <span class="opacity-icon">
                      <i class="pi pi-sun"></i>
                  </span>
                  <input
                    type="range"
                    min="0"
                    max="100"
                    [ngModel]="layerStates.weather.opacity"
                    (ngModelChange)="onLayerOpacityChange('weather', $event)"
                    [disabled]="!layerStates.weather.visible"
                    class="opacity-slider">
                  <span class="opacity-value">{{ layerStates.weather.opacity }}%</span>
                  <button
                    type="button"
                    class="visibility-toggle"
                    (click)="toggleLayerVisibility('weather')">
                    <i class="pi" [class.pi-eye]="layerStates.weather.visible" [class.pi-eye-slash]="!layerStates.weather.visible"></i>
                  </button>
                </div>
              }

              @if (hasIndexLayer()) {
                <div class="opacity-control-container" [class.is-hidden]="!layerStates.index.visible" [title]="getIndexLayerLabel()">
                  <span class="opacity-icon">
                      <i class="pi pi-images"></i>
                  </span>
                  <input
                    type="range"
                    min="0"
                    max="100"
                    [ngModel]="layerStates.index.opacity"
                    (ngModelChange)="onLayerOpacityChange('index', $event)"
                    [disabled]="!layerStates.index.visible"
                    class="opacity-slider">
                  <span class="opacity-value">{{ layerStates.index.opacity }}%</span>
                  <button
                    type="button"
                    class="visibility-toggle"
                    (click)="toggleLayerVisibility('index')">
                    <i class="pi" [class.pi-eye]="layerStates.index.visible" [class.pi-eye-slash]="!layerStates.index.visible"></i>
                  </button>
                </div>
              }
            </div>
          }


          <!-- Monitoring control (separate top-right container) -->
          <div class="map-monitoring-control">
            <button
              class="monitoring-btn"
              type="button"
              title="{{ 'MONITORING_POINTS' | translate }}"
              (click)="openMonitoringModal()">
              <img src="../../../../../assets/icons/main/light/point-elem.svg" width="20" height="20" alt="Monitoring Points">
            </button>
          </div>
          <app-map-context-menu
            [show]="showContextMenu"
            [position]="contextMenuPosition"
            (zoom)="onContextMenuZoom()"
            (addPoint)="addMonitoringPointAtContextMenu()"
          ></app-map-context-menu>
        </div>
      </div>

      <!-- Monitoring Points Dialog -->
      <app-monitoring-points-dialog
        [(visible)]="showMonitoringPointsModal"
        [monitoringObjects$]="monitoringPointManager.monitoringObjects$"
        [openStreetMapComponent]="openstreetmapComponent"
        [isLoading]="isLoadingMonitoringObjects"
        [popupPosition]="{ top: 100, right: 20 }"
        (openWeatherModal)="onOpenWeatherFromDialog($event)"
        (openAllPointsChart)="showAllPointsChartModal = true"
        (deletePoint)="reloadMonitoringPoints()"
        (deletePolygon)="reloadMonitoringPoints()"
      ></app-monitoring-points-dialog>

      <!-- Weather Details Modal -->

      @if (showWeatherDetailsModal) {
        <app-point-polygon-details-modal
          [(visible)]="showWeatherDetailsModal"
          [latitude]="selectedPointForWeather?.latitude"
          [longitude]="selectedPointForWeather?.longitude"
          [pointName]="selectedPointForWeather?.data?.name"
          [pointData]="selectedPointForWeather?.data"
          [date]="filterModel.DATE"
          [regionPathString]="getLastRegionPath()"
          (closed)=" afterCloseWeatherDetailsModal()"
          (addPoint)="reloadMonitoringPoints($event)"
          (export)="openExportModal($event)"
        ></app-point-polygon-details-modal>
      }

      <app-all-points-chart-modal
        [(visible)]="showAllPointsChartModal"
        [dataSourceOptions]="dataSourceOptions"
        [monitoringPoints]="monitoringPointManager.monitoringObjects$ | async"
      ></app-all-points-chart-modal>

      <!-- Export Modal -->
      <app-export-dialog
        [(visible)]="showExportModal"
        [coordinates]="exportCoordinates"
        [exportDataSourceOptions]="dataSourceOptions"
      ></app-export-dialog>
    </div>
  </div>

  <div right #right>
    <msf-filters
      [export]="true"
      [fields]="filterFields"
      [(ngModel)]="filterModel"
      [isLoading]="isLoadingFilters"
      (applyFilter)="filterFieldsChange()"
      (clearFilter)="clearFilters()"
      (modelChange)="filterFieldsChange()"
      (exportChange)="openExportModal()"
    ></msf-filters>
  </div>

</msf-list-page-wrapper>
